<template>
    <div class="sidebar">        
        <div class="menu-items">
            <div class="menu">        
                <router-link to="/profile" active-class="active" exact class="side-btn">
                    <div class="link-container">
                        <!-- svg icon -->
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 3H3V9H9V3Z" stroke="currentColor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19 3H13V9H19V3Z" stroke="currentColor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19 13H13V19H19V13Z" stroke="currentColor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 13H3V19H9V13Z" stroke="currentColor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <!-- svg icon end-->
                        <h2>Dashboard</h2>  
                    </div>
                </router-link>           
            <router-link to="/kyc" active-class="active" v-if="!$store.state.iskyc" exact class="side_btn kyc_btn_hidn">
                <div class="btn">
                    <!-- svg icon -->
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2H6C5.50272 2 5.35163 2.66243 5 3C4.64837 3.33757 4 3.52261 4 4V18C4 18.4774 4.64837 18.6624 5 19C5.35163 19.3376 5.50272 20 6 20H17C17.4973 20 17.6484 19.3376 18 19C18.3516 18.6624 19 18.4774 19 18V8L12 2Z" stroke="currentcolor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 2V8H18" stroke="currentcolor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <!-- svg icon end-->
                    <h2>Complete KYC</h2>
                </div>
            </router-link>        
            <router-link to="/invest/#investStartup" active-class="active" v-else exact class="side_btn kyc_btn_hidn">
                <div class="btn">
                    <!-- svg icon -->
                    <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 9C1 9 4.63636 1 11 1C17.3636 1 21 9 21 9C21 9 17.3636 16 11 16C4.63636 16 1 9 1 9Z" stroke="currentcolor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M11 11C12.6569 11 14 9.65685 14 8C14 6.34315 12.6569 5 11 5C9.34315 5 8 6.34315 8 8C8 9.65685 9.34315 11 11 11Z" stroke="currentcolor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <!-- svg icon end-->
                    <h2>View Deals</h2>
                </div>
            </router-link>
            </div>
           <div class="menu" id="loggingBoxid">
                <router-link to="/profile/setting" active-class="active"  exact class="side-btn">
                <div class="link-container">
                    <!-- svg icon -->
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14Z" stroke="currentColor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 14C17.879 14.2742 17.9465 14.7051 18 15C18.0535 15.2949 17.7904 14.7857 18 15V15C18.169 15.1689 17.9085 15.7793 18 16C18.0915 16.2207 19 16.7611 19 17C19 17.2389 18.0915 16.7793 18 17C17.9085 17.2207 18.169 17.8311 18 18C17.8311 18.169 17.2207 17.9085 17 18C16.7793 18.0915 17.2389 19 17 19C16.7611 19 16.2207 18.0915 16 18C15.7793 17.9085 16.1689 18.169 16 18H15C14.7857 17.7904 15.2949 18.0535 15 18C14.7051 17.9465 14.2742 17.879 14 18C13.7311 18.1152 13.1615 17.7561 13 18C12.8385 18.2439 13.0012 18.7075 13 19V19C13 19.4822 12.341 19.659 12 20C11.659 20.341 11.4822 21 11 21C10.5178 21 10.341 20.341 10 20C9.65902 19.659 9 19.4822 9 19V19C8.99296 18.6991 9.1751 18.2448 9 18C8.8249 17.7552 8.28249 18.1039 8 18C7.7258 17.879 7.2949 17.9465 7 18C6.7051 18.0535 7.21425 17.7904 7 18V18C6.83114 18.169 6.22072 17.9085 6 18C5.77928 18.0915 5.23894 19 5 19C4.76106 19 5.22072 18.0915 5 18C4.77928 17.9085 4.16886 18.169 4 18C3.83095 17.8311 4.0915 17.2207 4 17C3.9085 16.7793 3 17.2389 3 17C3 16.7611 3.9085 16.2207 4 16C4.0915 15.7793 3.83095 16.1689 4 16V15C4.20958 14.7857 3.94653 15.2949 4 15C4.05347 14.7051 4.12101 14.2742 4 14C3.88476 13.7311 4.2439 13.1615 4 13C3.7561 12.8385 3.29253 13.0012 3 13V13C2.51779 13 2.34098 12.341 2 12C1.65902 11.659 1 11.4822 1 11C1 10.5178 1.65902 10.341 2 10C2.34098 9.65902 2.51779 9 3 9V9C3.3009 8.99296 3.75519 9.1751 4 9C4.24481 8.8249 3.89611 8.28249 4 8C4.12101 7.7258 4.05347 7.2949 4 7C3.94653 6.7051 4.20958 7.21425 4 7V7C3.83095 6.83114 4.0915 6.22072 4 6C3.9085 5.77928 3 5.23894 3 5C3 4.76106 3.9085 5.22072 4 5C4.0915 4.77928 3.83095 4.16886 4 4C4.16886 3.83095 4.77928 4.0915 5 4C5.22072 3.9085 4.76106 3 5 3C5.23894 3 5.77928 3.9085 6 4C6.22072 4.0915 5.83114 3.83095 6 4H7C7.21425 4.20958 6.7051 3.94653 7 4C7.2949 4.05347 7.7258 4.12101 8 4V4C8.26888 3.88476 8.83848 4.2439 9 4C9.16152 3.7561 8.99883 3.29253 9 3V3C9 2.51779 9.65902 2.34098 10 2C10.341 1.65902 10.5178 1 11 1C11.4822 1 11.659 1.65902 12 2C12.341 2.34098 13 2.51779 13 3V3C13.0012 3.29253 12.8385 3.7561 13 4C13.1615 4.2439 13.7311 3.88476 14 4C14.2742 4.12101 14.7051 4.05347 15 4C15.2949 3.94653 14.7857 4.20958 15 4V4C15.1689 3.83095 15.7793 4.0915 16 4C16.2207 3.9085 16.7611 3 17 3C17.2389 3 16.7793 3.9085 17 4C17.2207 4.0915 17.8311 3.83095 18 4C18.169 4.16886 17.9085 4.77928 18 5C18.0915 5.22072 19 4.76106 19 5C19 5.23894 18.0915 5.77928 18 6C17.9085 6.22072 18.169 5.83114 18 6V7C17.7904 7.21425 18.0535 6.7051 18 7C17.9465 7.2949 17.879 7.7258 18 8V8C18.1152 8.26888 17.7561 8.83848 18 9C18.2439 9.16152 18.7075 8.99883 19 9V9C19.4822 9 19.659 9.65902 20 10C20.341 10.341 21 10.5178 21 11C21 11.4822 20.341 11.659 20 12C19.659 12.341 19.4822 13 19 13V13C18.7075 13.0012 18.2439 12.8385 18 13C17.7561 13.1615 18.1152 13.7311 18 14V14Z" stroke="currentColor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <!-- svg icon end-->
                    <h2> Settings</h2>
                </div>
            </router-link>            
            <button v-on:click="loggingBox=!loggingBox" class="side-btn lout_btn_hidn">
                <div class="link-container">
                    <!-- svg icon -->
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2H17C17.4301 2 18.6959 2.64576 19 3C19.3041 3.35424 19 3.49904 19 4V17C19 17.501 19.3041 17.6458 19 18C18.6959 18.3542 17.4301 19 17 19H14" stroke="currentColor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8 7L3 11L8 16" stroke="currentColor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M3 11H14" stroke="currentColor" stroke-width="1.85707" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <!-- svg icon end-->
                <h2>Logout</h2>
                </div>
            </button>
            <!-- logging out -->
            <div class="logging_main_div" v-show="loggingBox">
                <div class="close_btn" v-show="loggingBox" v-on:click="loggingBox=!loggingBox">
                    <span>
                            <svg xmlns="http://www.w3.org/2000/svg" height="26px" viewBox="0 0 24 24" width="26px" fill="#ffffff"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"></path></svg>
                    </span>
                </div>
                <div class="logging_inr_div">
                    <div class="error_icon">
                        <div class="bordr">
                          <svg xmlns="http://www.w3.org/2000/svg" height="26px" width="26px" viewBox="0 0 128 512"><path d="M64 352c17.69 0 32-14.32 32-31.1V64.01c0-17.67-14.31-32.01-32-32.01S32 46.34 32 64.01v255.1C32 337.7 46.31 352 64 352zM64 400c-22.09 0-40 17.91-40 40s17.91 39.1 40 39.1s40-17.9 40-39.1S86.09 400 64 400z"/></svg>
                        </div>
                    </div>
                    <div class="logging_text">
                        <p class="not_one">Are you leaving ?</p>
                        <p class="not_two">Are you sure want to logout ?.</p>
                    </div>
                    <div class="logging_btn_div">
                        <button class="log_one" @click.prevent="handleLogout">Yes</button>
                        <button class="log_two" @click="closeModal">no</button>
                    </div>
                </div>
            </div>
            <div class="bg" v-show="loggingBox" v-on:click="loggingBox=!loggingBox"></div>
         <!--end logging out -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    // -next-line vue/multi-word-component-names
    name:'Sidebar',
    el:'#loggingBoxid',
      data() {
          return {
              loggingBox: false,
             
          }
      },
    methods:{
        handleLogout(){
            this.$store.dispatch("logout");
        },
        closeModal () {
            this.loggingBox = false;
        },
    }
}
</script>

<style lang="postcss" scoped>
.side_btn{
    @apply inline-flex items-center z-[1] text-black font-medium bg-gradient-to-br from-invbtn to-invbtn2 border-0 my-4 xl:mr-[1.7rem] py-3 px-4  focus:outline-none rounded-[2.599rem] text-lg;
    &:hover{
        @apply hover:bg-gradient-to-br from-hover to-hover;
    }
}
.btn{
    @apply flex items-center;
}
.btn h2{
    @apply ml-4 md:text-[0.8rem]  lg:text-[1rem];
}
.link-container{
    @apply flex pl-5;
    h2{
    @apply ml-4;
    }
}
.menu-items{
    @apply  flex flex-col justify-between my-14 ml-4 min-h-[73vh];
}
.menu{
    @apply grid;
}
.side-btn{
    @apply relative border-none text-menutext py-3 focus:outline-none;
}
.side-btn:hover{
    @apply text-borderclr;
}
.side-btn.active{
    @apply relative bg-clr9 text-borderclr rounded-tl-full rounded-bl-full;
}
.side-btn.side-btn.active::before{
    @apply -top-7;
}
.side-btn.active::after {
    @apply -bottom-7;
}
.side-btn.active::before, .side-btn.active::after {
   @apply absolute table content-[''] right-0 h-7 w-7 bg-clr9;            
}
.side-btn.active .link-container::before {
    @apply -top-[60px];
}
.side-btn.active .link-container::after {
    @apply -bottom-[60px] z-[1];    
}
.side-btn.active .link-container::before, .side-btn.active .link-container::after {
    @apply absolute content-[''] right-0 h-[60px] w-[60px] rounded-full bg-navbg;
}
.logging_main_div{ 
    transform: translate(-50%, -50%);
    @apply fixed top-1/2 left-1/2 z-[99999] flex justify-center flex-col text-center p-6 min-w-[350px] bg-fotxthd rounded-lg;
    .close_btn{
        @apply absolute top-[-14px] right-[-15px] cursor-pointer bg-navbg w-10 h-10 rounded-full flex justify-center items-center;    
    }
    .logging_inr_div{
        .error_icon{
            @apply flex justify-center;
            .bordr{
                @apply flex justify-center items-center border-2 border-black rounded-full w-9 h-9;
                svg{
                    @apply m-auto;
                }
            }
        }
        .logging_text{ @apply my-4;
            .not_one{ @apply text-sm capitalize; }
            .not_two{ @apply text-base capitalize;}
        }
        .logging_btn_div{ @apply flex justify-evenly items-center;
            .log_one{
                @apply inline-flex items-center border-2 border-navbg bg-navbg capitalize py-2 px-8 text-base font-medium text-center text-whitergb rounded-lg;
                &:hover{
                    @apply hover:bg-gradient-to-br text-black from-hover to-hover;
                }
            }
            .log_two{
                @apply inline-flex items-center border-2 border-navbg capitalize py-2 px-8 text-base font-medium text-center text-navbg rounded-lg;
                &:hover{
                    @apply hover:bg-gradient-to-br text-black from-hover to-hover;
                }
            }
        }
    }
}
</style>